<template>
  <div class="box6">
    <a @click="openPop">添加老师，免费激活学习</a>
  </div>
</template>

<script>
export default {
  components: {
    
  },
  data() {
    return {
     
    };
  },
  computed: {
    
  },
  methods:{
    openPop(){
      this.$emit('openPop')
    }
  }
};
</script>

<style lang="less" scoped>
.box6 {
  position: relative;

  width: 100%;
  height:1648px;
  background: url("../../../assets/coursePage/design/box6/img01.png") no-repeat;
  background-size: cover;
  background-position: center;
position: relative;
  box-sizing: border-box;
  a{
    width: calc(100% - 64px);
    height: 88px;
    position: absolute;
    bottom:88px;
    left: 32px;
    background: #303433;
    border-radius: 40px;
    display: block;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 32px;
    color: #FFFFFF;
    line-height: 88px;
    text-align: center;
    font-style: normal;

  }
}
</style>
